module.exports = __webpack_public_path__ + "img/festival-titulo.e04c4eac.png";